import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Slider from './Slider';
import { MeasuredContainer, measuredDefaultSize, MeasuredCookieType, ScreenSizeContext } from '../Measured';
import { getSliderConfiguration } from './helpers';
import { BREAKPOINTS as breakpoints } from './constants';
const MeasuredSlider = (_param)=>{
    var { children , renderSliderItems  } = _param, restProps = _object_without_properties(_param, [
        "children",
        "renderSliderItems"
    ]);
    const { width: screenWidth  } = useContext(ScreenSizeContext);
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(MeasuredContainer, {
        cookieType: MeasuredCookieType.SLIDER,
        cookieDim: 'width',
        defaultSize: measuredDefaultSize,
        listenOnWindow: true,
        limitToParentWidth: true
    }, (measuredProps)=>{
        const containerWidth = measuredProps.container && measuredProps.container.width;
        const { elementWidth , elementHeight  } = getSliderConfiguration({
            breakpoints,
            screenWidth,
            containerWidth,
            dontScale: isMobile
        });
        return /*#__PURE__*/ React.createElement(Slider, _extends({}, restProps), renderSliderItems({
            width: elementWidth,
            height: elementHeight
        }));
    });
};
MeasuredSlider.displayName = 'MeasuredSlider';
export default MeasuredSlider;
